import Page from './fr/index';

export default Page;
